"use strict";
/*
  The MIT License

  Copyright (c) 2017-2019 EclipseSource Munich
  https://github.com/eclipsesource/jsonforms

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in
  all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
  THE SOFTWARE.
*/
Object.defineProperty(exports, "__esModule", { value: true });
exports.iterateSchema = exports.unsetReadonly = exports.setReadonly = void 0;
var tslib_1 = require("tslib");
var isEmpty_1 = tslib_1.__importDefault(require("lodash/isEmpty"));
var models_1 = require("../models");
var setReadonlyPropertyValue = function (value) { return function (child) {
    if (!child.options) {
        child.options = {};
    }
    child.options.readonly = value;
}; };
var setReadonly = function (uischema) {
    exports.iterateSchema(uischema, setReadonlyPropertyValue(true));
};
exports.setReadonly = setReadonly;
var unsetReadonly = function (uischema) {
    exports.iterateSchema(uischema, setReadonlyPropertyValue(false));
};
exports.unsetReadonly = unsetReadonly;
var iterateSchema = function (uischema, toApply) {
    if (isEmpty_1.default(uischema)) {
        return;
    }
    if (models_1.isLayout(uischema)) {
        uischema.elements.forEach(function (child) { return exports.iterateSchema(child, toApply); });
        return;
    }
    toApply(uischema);
};
exports.iterateSchema = iterateSchema;
//# sourceMappingURL=uischema.js.map